<template>
  <section class="intro">
    <div class="intro__wrap">
      <h1 class="intro__title">desperately under construction</h1>
      <img class="intro__blob" :src="Blop" alt="">
    </div>
    <div class="intro__scroll">
      <p class="intro__scroll__text">hosted by <a class="link" href="https://desperate.dk">desperate.</a></p>
    </div>
  </section>
</template>

<script>
import Blop from '@/assets/blop.png';
import './style.scss';
import Header from '@/components/Header/Header';
import SweetScroll from 'sweet-scroll';

export default {
  name: 'IntroBox',
  data() {
    return {
      Blop,
    };
  },
  mounted() {
    const is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    this.scroller = is_safari ? new SweetScroll({}, '.main-wrapper') : new SweetScroll({});
  },
  methods: {
    scroll() {
      this.scroller.to(window.innerHeight);
    },
  },
  components: {
    Header,
  },
  props: {
    trigger: Function,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/IntroBox/IntroBox.vue